import { SharedMainModule } from '@app/shared/mainComponent/main-shared.module';

export const imports = [SharedMainModule];
